/**************************************************
 * Nombre:       IngresoSelectFalsoVerdadero
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {InputAdornment, MenuItem, TextField} from "@mui/material";
import {Brightness1} from "@mui/icons-material";
import {useEffect, useState} from "react";


const IngresoSelectFalsoVerdadero = ({
                                         props,
                                         nombre,
                                         dato,
                                         Icono = Brightness1,
                                         requerido = false,
                                         size = 'small',
                                         editable = true,
                                         setDato
                                     }) => {
    const {register, errors, control, watch, setValue, getValues} = props
    const [seleccion, setSeleccion] = useState(false)

    const cambio = (e) => {
        if (e === opciones[0]) {
            setValue(dato, true)
        } else {
            setValue(dato, false)
        }
    }


    useEffect(() => {

        let valor = getValues(dato)
        if (valor) {
            setSeleccion(opciones[0])
        } else {
            setSeleccion(opciones[1])
        }

    }, [watch(dato)])
    return (
        <TextField
            slotProps={{
                input: {
                    startAdornment: (

                        <InputAdornment position="start">
                            <Icono color={'primary'}/>
                        </InputAdornment>
                    ),
                    disableUnderline: true,
                },
                inputLabel: {
                    sx: {marginLeft: -1}
                }
            }
            }
            // color={'info'}
            disabled={!editable}
            fullWidth
            size={size}
            label={nombre}
            required={requerido}
            error={!!errors[dato]}
            value={seleccion}
            onChange={e => cambio(e.target.value)}
            helperText={errors[dato]?.message}
            select>

            {opciones.map((c, i) => (
                <MenuItem key={`c-${i}`} value={c}>
                    {c}
                </MenuItem>
            ))}
        </TextField>

    )

}
export default IngresoSelectFalsoVerdadero

const opciones = ['Si', 'No']
